module.exports = __webpack_public_path__ + "img/red-cross-bold-icon.34f9e603.svg";